var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m17.15 13.138-6.038-1.966v4.33l1.518 1.19v1.173l-2.639-.775-2.621.775v-1.172l1.482-1.191v-4.33L2.85 13.138v-1.55l6.002-3.951v-4.33q0-.491.325-.831a1.08 1.08 0 0 1 .814-.34q.488 0 .804.34t.317.831v4.33l6.038 3.951z"
})));
export default SvgPark;